import { useQuery } from '@tanstack/react-query';
import API from 'api/API';
import { OrdersRequestParams, OrderStatus, OrderSummary } from 'api/models/Orders';
import { QueryKeys } from 'api/models/QueryKeys';

export const useSearchOrders = (request: OrdersRequestParams) => {
  const query = useQuery({
    queryKey: [QueryKeys.SearchOrders, request],
    queryFn: async () => API.orders.getOrders(request),
    enabled: false, // this is triggered manually with refetch() in the component
  });

  const filterUnwantedStatuses = (result?: OrderSummary[]) => {
    const unwantedStatuses: OrderStatus[] = ['CHECK_OUT', 'CANCELED', 'DELETED'];
    return result?.filter(order => !unwantedStatuses.includes(order.status)) || [];
  };

  return {
    ...query,
    // client side filtering because BE doesnt support filter lists
    data: filterUnwantedStatuses(query.data?.result),
    refetch: async () => {
      const res = await query.refetch();
      return {
        ...res,
        data: filterUnwantedStatuses(res.data?.result),
      };
    },
    // isLoading will always be true because the query is never enabled
    isLoading: query.isFetching,
  };
};
